import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FilterContainerComponent } from './filter.container.component';
import { ResetFormModule } from '../resetForm/reset.form.module';
import { ShowResultsModule } from '../showResults/showresults.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ShowResultsModule,
    ResetFormModule,
    FilterContainerComponent,
  ],
  exports: [FilterContainerComponent],
})
export class FilterContainerModule {}
